{
  "previous": "上一步",
  "next": "下一步",
  "complete": "完成",
  "verifyAndCheckIn": "验证并签到",
  "loading": {
    "retrievingLocation": "正在获取位置...",
    "retrievingWarehouse": "正在获取仓库数据..."
  },
  "validation": {
    "fieldRequired": "此字段为必填项",
    "fieldRequiredWithLabel": "{label} 为必填项",
    "phoneInvalid": "该电话号码无效",
    "phoneInvalidWithExample": "该电话号码无效（示例：{example}）"
  }
}
